export default __webpack_public_path__ + "static/media/zory.c4d848ce.svg";